import '.cq{border-radius:24px;}.ssr-plugin'
import '.dx{padding:0px;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.di{cursor:pointer;}.ssr-plugin'
import '.f1{transition:all .2s ease-out;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.u{border-radius:16px;}.ssr-plugin'
import '.ay{overflow:hidden;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.d6{object-fit:cover;}.ssr-plugin'
import '.aq{display:block;}.ssr-plugin'
import '.fw{user-select:none;}.ssr-plugin'
import '.fx{-webkit-user-select:none;}.ssr-plugin'
import '.bg{aspect-ratio:1/1;}.ssr-plugin'
import '.fy{-moz-user-select:none;}.ssr-plugin'
import '.ca{text-align:left;}.ssr-plugin'
import '.fz{line-height:125%;}.ssr-plugin'
import '.g0{align-items:flex-start;}.ssr-plugin'
import '.g1{gap:8px;}.ssr-plugin'
import '.g2{margin-top:2px;}.ssr-plugin'
import '.g3{margin-top:auto;}.ssr-plugin'
import '.e3{padding-top:20px;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { Icon } from '../assets/icons/index.js'
import { VoteButton } from './VoteButton.js'
import { colors } from '../utils/colors.js'
import {
  useVotingRegion,
  useVotingRegionName,
} from '../hooks/useVotingRegion.js'
import { Flag } from './Flag.js'
import { parseContestantImageSrc } from '../utils/parseImageSrc.js'

type CardProps = {
  img?: string
  ddi?: number | string
  name?: string
  song?: string
  votingRegion: string
  votes: Record<string, number>
  setVotes?: (selected: Record<string, number>) => void
  setModal: (x?: any) => any
  setModalIndex?: () => any
  maxed?: boolean
  style?: Style
}

export const Card = ({
  img,
  ddi,
  name,
  song,
  votingRegion,
  setModal,
  setModalIndex,
  votes,
  setVotes,
  maxed,
  style,
}: CardProps) => {
  const votingRegionName = useVotingRegionName(votingRegion as string)
  const [{ voteType }] = useVotingRegion()
  const isOnlineVoting = voteType === 'online'

  return (
    <styled.div className="cq dx ap b9 o p"
      id="voting-page-contestant-card-content"
      style={{
        backdropFilter:
          votes?.[votingRegion] && isOnlineVoting ? 'blur(4px)' : 'blur(0px)',
        WebkitBackdropFilter:
          votes?.[votingRegion] && isOnlineVoting ? 'blur(4px)' : 'blur(0px)',
        '& > *': {
          position: 'relative',
        },
        '& h2': {
          fontFamily: 'Neulis-Regular',
          fontWeight: '600',
          letterSpacing: '-0.02em',
          fontSize: 16,
          marginBlockStart: 0,
          marginBlockEnd: 8,
          textAlign: 'left',
        },
        '& p': {
          fontSize: 14,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        },
        '&::before': {
          content: '" "',
          scale: votes?.[votingRegion] ? 1 : 0.96,
          backgroundColor:
            votes?.[votingRegion] && isOnlineVoting
              ? colors.primary
              : 'transparent',
          position: 'absolute',
          inset: -8,
          opacity: 0.3,
          borderRadius: 24,
          transition: 'all .2s ease-out',
        },
        ...style,
      }}
    >
      <styled.div className="ap b3 di f1 ag u ay"
        style={{
          '&:hover': {
            scale: 0.985,
          },
          '&:hover::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: `${colors.border}`,
            zIndex: 1,
            pointerEvents: 'none',
            borderRadius: 16,
          },
          border: `1px solid ${colors.border}`,
        }}
        id="voting-page-contestant-card-action-open-contestant-modal"
        onClick={() => {
          setModalIndex?.()
          setModal(true)
        }}
      >
        <img className="a d6 aq fw fx bg fy u"
          src={parseContestantImageSrc(img as string, 324)}
          alt={name}
          loading="lazy"
          decoding="async"
          draggable={false}
          style={{
            backgroundColor: colors.secondary,
          }}
        />
      </styled.div>
      <h2 className="ca fz">
        {ddi} · {name}
      </h2>
      <div className="o g0 g1"
      >
        <Icon type="noteIcon" width={18} />
        <p className="ca g2">
          {song}
        </p>
      </div>
      <div className="o g0 g1"
      >
        <Flag code={votingRegion} width={18} />
        <p className="ca g2">
          {votingRegionName}
        </p>
      </div>
      <div className="g3 e3">
        <VoteButton
          id="voting-page-contestant-card-action-vote-button"
          votingRegion={votingRegion}
          votes={votes}
          setVotes={setVotes}
          maxed={maxed}
        />
      </div>
    </styled.div>
  )
}
